import Header from "@/components/Header";
import Hero from "@/components/Hero";
import WhyCoaches from "@/components/WhyCoaches";
import Features from "@/components/Features";
import HowItWorks from "@/components/HowItWorks";
import DashboardShowcase from "@/components/DashboardShowcase";
import FirstCoaches from "@/components/FirstCoaches";
import Pricing from "@/components/Pricing";
import FAQ from "@/components/FAQ";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <main className="relative min-h-screen bg-[#050814] text-white overflow-hidden">
      <Header />
      <Hero />
      <WhyCoaches />
      <Features />
      <HowItWorks />
      <DashboardShowcase />
      <FirstCoaches />
      <Pricing />
      <FAQ />
      <FinalCTA />
      <Footer />
    </main>
  );
}
